import { useState } from 'react';
import FiatCryptoTransactionPanel from '../FiatCryptoTransactionPanel';
import { useNavigate } from 'react-router-dom';
import MerchantTransferModal from '../TransactionForm/Transfer/MerchantTransferModal';
import Deposit from '../TransactionForm/Deposit';
import PayOut from '../TransactionForm/PayOut/PayOut';

const CreateTransactionSection = ({ tabs, button, activeCurrencyPage, fiatMenuOptions }) => {
    const filterArray = tabs.filter((data, index) => data.type === activeCurrencyPage);
    const [openModalKey, setOpenModalKey] = useState(null);
    const navigate = useNavigate();

    const handleOpenModal = key => {
        if (key === 'bulkPay') {
            navigate('/client/bulk-payment');
        }
        setOpenModalKey(key);
    };

    const handleCloseModal = () => {
        setOpenModalKey(null);
    };

    return (
        <div className="hidden lg:block h-full">
            <FiatCryptoTransactionPanel
                tabs={filterArray}
                menuOptions={fiatMenuOptions}
                activeCurrencyPage={activeCurrencyPage}
                onMenuItemClick={handleOpenModal}
            />
            {openModalKey === 'merchant' && (
                <MerchantTransferModal open={true} onClose={handleCloseModal} />
            )}
            {openModalKey === 'deposit' && <Deposit open={true} onClose={handleCloseModal} />}
            {openModalKey === 'paymentOut' && (
                <PayOut isModal={true} type="paymentOut" onClose={handleCloseModal} />
            )}
        </div>
    );
};

export default CreateTransactionSection;

/**
 * Renders the CreateTransactionSection component.
 *
 * @note Call the component and pass the required props: `tabs` and `fiatMenuOptions`,
 *       which you will get from `constant.js`.
 *
 * @example
 * <CreateTransactionSection
 *    tabs={actionTabs}
 *    activeCurrencyPage={activeCurrencyPage}
 *    menuOptions={menuOptions}
 * />
 */
